module.exports = __webpack_public_path__ + "img/th.ee909a8e.png";